import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M15.8699 72.7399C15.8699 72.7399 15.5599 65.3898 9.60994 62.5198C3.66994 59.6598 2.95994 54.1899 4.89994 49.4899C6.56994 45.4299 8.29994 41.77 4.98994 37.64C1.29994 33.03 1.02996 27.4999 3.00996 24.2099C5.29996 20.4099 10.21 20.0099 12.04 18.7099C14.45 16.9999 12.8299 9.93989 19.5299 6.81989C24.41 4.54989 28.2799 8.41989 32.4299 7.44989C36.8399 6.41989 38.36 0.509927 46.95 1.35993C55.25 2.18993 55.97 8.25987 60.23 9.92987C64.79 11.7299 70.88 7.69992 75.4399 11.7299C80.1399 15.8799 76.9699 20.8099 79.8699 25.8399C81.8299 29.2399 87.0599 29.8299 87.7499 35.6599C88.4399 41.4699 82.99 45.12 82.51 47.76C81.25 54.75 85.8099 56.4099 76.9899 63.1799C73.3099 66.0099 71.4899 68.2399 71.2699 71.3299L15.8699 72.7399Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
